(function () {
  // BO: Ikke vis lagerstatus på presale
  if (window.BO_PRESALE === true) return;

  // BO: Ikke vis lagerstatus på gavekort (settes fra main-product.liquid)
  if (window.BO_IS_GIFTCARD === true) return;

  const BADGE_ID = 'bo-stock-status';

function ensureBadgeElement() {
  if (
    !window.BO_STOCK_DATA ||
    !Array.isArray(window.BO_STOCK_DATA.variants) ||
    window.BO_STOCK_DATA.variants.length === 0
  ) {
    return null;
  }

  const buyButtonsBlock =
    document.querySelector('[data-block-type="buy-buttons"]') ||
    document.querySelector('.buy-buttons') ||
    document.querySelector('form[action*="/cart/add"]');

  if (!buyButtonsBlock) return null;

  let el = document.getElementById(BADGE_ID);

  if (!el) {
    el = document.createElement('div');
    el.id = BADGE_ID;
    el.className = 'product-stock-status';
  }

  if (!buyButtonsBlock.contains(el)) {
    buyButtonsBlock.prepend(el);
  }

  return el;
}
  function renderBadge(variant) {
  if (window.BO_IS_GIFTCARD === true) return;

  const el = ensureBadgeElement();
  if (!el) return;

  // COMING SOON override: hvis produktet er markert, vis alltid "Coming soon"
  if (window.BO_COMING_SOON === true) {
    el.textContent = 'Coming soon';
    el.className = 'product-stock-status bo-soon';
    return;
  }

  // Ingen variant valgt
  if (!variant) {
    el.textContent = '';
    el.className = 'product-stock-status';
    return;
  }

  // Utsolgt
  if (!variant.available) {
    el.textContent = 'Out of stock';
    el.className = 'product-stock-status bo-red';
    return;
  }

  const qty = Number(variant.qty || 0);

  if (qty > 20) {
    el.textContent = 'In Stock';
    el.className = 'product-stock-status bo-green';
  } else if (qty >= 10 && qty <= 20) {
    el.textContent = 'Few in stock';
    el.className = 'product-stock-status bo-yellow';
  } else if (qty >= 1 && qty <= 9) {
    el.textContent = `Only ${qty} left`;
    el.className = 'product-stock-status bo-orange';
  } else {
    el.textContent = 'Out of stock';
    el.className = 'product-stock-status bo-red';
  }
}


  function findVariantById(id) {
    const data = window.BO_STOCK_DATA;
    if (!data || !Array.isArray(data.variants)) return null;
    return data.variants.find(v => String(v.id) === String(id)) || null;
  }

  function initFromHiddenInput() {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input || !input.value) {
      renderBadge(null);
      return;
    }
    const v = findVariantById(input.value);
    renderBadge(v);
  }

  // Lytt til temaets variant-event (Prestige/Dawn emiterer 'variant:change')
  document.addEventListener('variant:change', function (e) {
    if (window.BO_IS_GIFTCARD === true) return;

    const variant = e.detail && e.detail.variant;
    if (!variant) return;

    const v = findVariantById(variant.id);
    renderBadge({
      id: variant.id,
      qty: v ? v.qty : 0,
      available: !!variant.available
    });
  });

  // Fallback: endring av hidden input 'id'
  document.addEventListener('change', function (e) {
    if (window.BO_IS_GIFTCARD === true) return;

    const t = e.target;
    if (t && t.name === 'id') {
      const v = findVariantById(t.value);
      renderBadge(v);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (window.BO_IS_GIFTCARD === true) return;
    initFromHiddenInput();
  });
})();
